import { getAnalytics, setUserId } from 'firebase/analytics'
import { useEmailUserContext } from 'fitify-ui-onboarding/src/contexts/EmailUserContext'
import { useEventContext } from 'fitify-ui-onboarding/src/contexts/EventContext'
import { logEvent } from 'fitify-ui-onboarding/src/utils/analytics'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useEffect } from 'react'
import smartlookClient from 'smartlook-client'

import type { DataPathState, DataState, FunnelDataPath } from 'types/state'

export const useUserAnalytics = (
  data: DataState,
  funnelData?: DataPathState<FunnelDataPath>
) => {
  const { pushUserData } = useEventContext()
  const { emailUser } = useEmailUserContext()
  const growthBook = useGrowthBook()

  useEffect(() => {
    if (emailUser) {
      setUserId(getAnalytics(), emailUser.uid)
      smartlookClient.identify(emailUser.uid, {
        name: emailUser.displayName || '',
        email: emailUser.email || '',
      })

      // User provider from authUser if exists, otherwise default to 'password'
      const userProvider = 'password'

      pushUserData({
        email_address: emailUser.email,
        external_id: emailUser.uid,
      })
      logEvent('signup', { provider_id: userProvider })
    }
  }, [emailUser, pushUserData])

  useEffect(() => {
    if (funnelData?.gender) {
      pushUserData({
        gender: funnelData?.gender,
      })
    }
  }, [funnelData?.gender, pushUserData])

  useEffect(() => {
    const appUserName = emailUser?.displayName
    const dataName =
      funnelData && 'displayName' in funnelData
        ? funnelData.displayName
        : undefined

    if (appUserName || dataName) {
      pushUserData({
        address: {
          first_name: appUserName || dataName,
        },
      })
    }
  }, [emailUser?.displayName, funnelData, pushUserData])

  useEffect(() => {
    const location = data.common?.user_location?.data

    if (location) {
      pushUserData({
        address: {
          city: location.city,
          country: location.countryCode,
          region: location.region,
          zip: location.postalCode,
        },
      })
    }
  }, [data.common?.user_location?.data, pushUserData])

  useEffect(() => {
    const location = data.common?.user_location?.data
    const country = location?.countryCode
    const region = location?.regionIso

    if (growthBook.ready && country) {
      void growthBook.updateAttributes({ country, region })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    data.common?.user_location?.data?.countryCode,
    data.common?.user_location?.data?.regionIso,
    growthBook.ready,
  ])
}
